import React from "react";
import styles from "./PluginDetailsItem.module.css";
import classNames from "classnames";
import PropTypes from "prop-types";

/**
 * Shows details about a user/group in the details modal for the plugins pages.
 */
export function PluginDetailsItem({ src, name, isGroup, id }) {
  let idText = "";

  if (isGroup) {
    idText = "Group ID: " + id;
  } else {
    idText = "User ID: " + id;
  }

  return (
    <>
      <div className={styles.container}>
        {/* <img className={styles.src} src={src} alt="thumbnail" /> */}
        <div className={styles.detailText}>
          <div className={styles.name}>{name}</div>
          <div className={styles.id}>{idText}</div>
        </div>
      </div>
    </>
  );
}

PluginDetailsItem.propTypes = {
  /**
   * Src for the image
   */
  src: PropTypes.string,
  /**
   * Name shown in bold
   */
  name: PropTypes.string,
  /**
   * If true “Group ID:” will be displayed if false “User ID:” will be displayed
   */
  isGroup: PropTypes.bool,
  /**
   * ID of the group/user
   */
  id: PropTypes.string,
};
